<template>
 
  <div class="demo-image__placeholder">
   <div class="block">
     <el-image :src="help"></el-image>
   </div>
   </div>
   
   <div style="height:600px">
  <div class="hele-bg1"> 
     <div class="help-space">
      <el-space :size="30">
     <el-button size="mini"
            type="primary"
            icon="el-icon-s-promotion"
            style="padding-right: 10px" @click="handleToLogin()" plain><el-text>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ $t('contact.backToLoginPage', { msg: 'contact.backToLoginPage' }) }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-text></el-button>
   </el-space>  
    <h3><p>{{ $t('help.welcome', { msg: 'help.welcome' }) }}</p></h3>
    </div>
  <el-tabs style="height: auto" type="border-card">
     <el-tab-pane :label="$t('help.tab1', { msg: 'help.tab1' })">
         <div style="text-align: left;">&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('help.info1', { msg: 'help.info1' }) }} {{ $t('help.info2', { msg: 'help.info2' }) }}
 <br>&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('help.info3', { msg: 'help.info3' }) }}<b>{{ $t('help.salesEmail', { msg: 'help.salesEmail' }) }}</b>
  {{ $t('help.info4', { msg: 'help.info4' }) }}
 {{ $t('help.info5', { msg: 'help.info5' }) }}
 {{ $t('help.info6', { msg: 'help.info6' }) }}
 {{ $t('help.info7', { msg: 'help.info7' }) }}</div>
 
 <!-- <p>&nbsp;&nbsp;Issuebye.com is an issue recording, solving and tracking cloud platform developed by Shanghai Compass Computer Co., Ltd., which can help you build up own knowledge base, and also its existing knowledge base can be utilized as well.
 you can log in to this cloud platform system by double clicking the icon on the desktop or login www.issuebye.com.
 If you need more accounts or after free of charge period, the administrator of your company can contact the sales of Shanghai Compass Computer Co., Ltd. by email: sales@shcompass.com.
 Click on 'Add Issue' in the top corner of the page, select the company on the pop-up page, and enter the title of issue in the title bar.
 Select the type of issue in the Type selection. If there is no type available, you can add them in the New Type session.
 Describe the content of the issue in detail in the content, set the priority, prioritize the higher the priority, and then click OK to add an issue that we just added to the main page.
 Double clicking on the issue, a new session on the right will display the issue details. The content of the issue can be added according to the progress of the issue solving. Fill in the statuses of issue handling in according to the nodes of issue handling.
 At the same time, this Issue cloud platform also provides you with existing shared files and knowledge base.
 If you need detailed instruction, you can email: service@shcompass.com to acquire the latest version.</p> -->
     </el-tab-pane>
 
     <el-tab-pane :label="$t('help.tab2', { msg: 'help.tab2' })"> 
         <p><el-link type="success" @click="downloadFile" :underline="true">{{ $t('help.oprManul', { msg: 'help.oprManul' }) }}</el-link></p>    
         <!-- 这个需要单独一个页面开发 -->
     </el-tab-pane>
 
     <el-tab-pane :label="$t('help.tab3', { msg: 'help.tab3' })">
 
   <!-- <div class="demo-image__placeholder">
   <div class="block">
     <el-image :src="userKnow"></el-image>
   </div>
   </div> -->
   <h4>{{ $t('help.info8', { msg: 'help.info8' }) }}</h4>
 <p>
     <span>
   <b> {{ $t('help.tip1', { msg: 'help.tip1' }) }} </b>{{ $t('help.info9', { msg: 'help.info9' }) }}
 </span>
   <br>
   <span>
   <b> {{ $t('help.tip2', { msg: 'help.tip2' }) }} </b> {{ $t('help.info10', { msg: 'help.info10' }) }}
 </span>
   <br><span>
   <b> {{ $t('help.tip3', { msg: 'help.tip3' }) }} </b> {{ $t('help.info11', { msg: 'help.info11' }) }}
  </span>   
   <span><br>
   <b> {{ $t('help.tip4', { msg: 'help.tip4' }) }} </b>{{ $t('help.info12', { msg: 'help.info12' }) }}
   <br></span>
   <b> {{ $t('help.tip5', { msg: 'help.tip5' }) }} </b> {{ $t('help.info13', { msg: 'help.info13' }) }}
   <span><br>
   <b> {{ $t('help.tip6', { msg: 'help.tip6' }) }} </b>{{ $t('help.info14', { msg: 'help.info14' }) }}
   <br></span>
   <b> {{ $t('help.tip7', { msg: 'help.tip7' }) }} </b> {{ $t('help.info15', { msg: 'help.info15' }) }}
  </p>
     </el-tab-pane>
     <el-tab-pane :label="$t('help.tab4', { msg: 'help.tab4' })">
    <p> <br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('help.info16', { msg: 'help.info16' }) }}</p>
     </el-tab-pane>
   </el-tabs>
 
   <div class="demo-imager-foot">
   <div class="block">
     <span class="demonstration"></span>
     <el-image :src="footer"></el-image>
   </div>
   <div class="block">
     <span class="demonstration"></span>
     <el-image :src="cetu">  
     </el-image>
   </div>
 </div>
 
 </div>
 
 <div class="demo-image_heng">
   <div class="block">
     <el-image :src="heng"></el-image>
   </div>
 </div>
 
 </div>
 </template>
 
 <script>
 export default {
     data() {
       return {
         tabPosition: 'left',
         help:'https://srb-data.oss-cn-beijing.aliyuncs.com/resFile/2023/12/06/help.png',
         userKnow:'https://srb-data.oss-cn-beijing.aliyuncs.com/resFile/2023/12/06/user_know.png',
         footer:'https://srb-data.oss-cn-beijing.aliyuncs.com/IssueFile/2024/04/16/service_help.png',
         cetu:'https://srb-data.oss-cn-beijing.aliyuncs.com/resFile/2023/12/06/help-right.png',
         heng:'https://srb-data.oss-cn-beijing.aliyuncs.com/resFile/2023/12/05/heng.png',
       };
     },
     created() {
   },
   methods:{
     //跳转到登录页
     handleToLogin(){
         this.$router.push({
       path:'/login',
      }); 
     },
     downloadFile() {
       // 创建一个<a></a>标签
       const a = document.createElement('a');
       a.href = 'https://srb-data.oss-cn-beijing.aliyuncs.com/IssueFile/2024/04/16/问题追踪处理云平台操作手册-V2.240416.docx';  //设置下载url
     //  a.download = '号码池导入';
      // a.style.display = 'none';
       // 将a标签追加到文档对象中
       document.body.appendChild(a);
       // 模拟点击了<a>标签,会触发<a>标签的href的读取,浏览器就会自动下载了
       a.click();
       // 一次性的,用完就删除a标签
       a.remove();
     },
 
 }
 
 
 }
 
 </script>
 
 <style>
 .hele-bg{
     background-image: url('https://srb-data.oss-cn-beijing.aliyuncs.com/resFile/2023/12/06/help_bg.jpg');
 }
 .p{
   text-align: left;  
 }
 .help-space{
     margin: 0 auto;
     display: flex; /*就是可以把多个标签放在一行展示，发不下的话再换行*/
 }
 .demo-imager-foot {
       margin: 0 auto;
       display: flex; /*就是可以把多个图片放在一行展示，发不下的话再换行*/
     }
 </style>